import { ConfigProvider } from 'antd';
import { type } from 'os';
import React, { useEffect } from 'react';
import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom';
import './App.less';
import routes from './config/routes';
import zhCN from 'antd/es/locale/zh_CN';
import moment from "moment";
import TimezoneProiver from './components/TimezoneProvier';
import "moment/locale/zh-cn";

// console.log("env=>", moment.tz.names());

moment.locale("zh-cn");

export default () => {


  const renderRoute = (route: any, index: number) => {

    const hasChildren = route.children ? true : false;
    const children = hasChildren ? [...route.children] : [];
    // console.log("props:", route,hasChildren,children);
    return (
      <>
        <Route key={route.path} path={route.path} index={route.index} element={

          hasChildren ? <route.layout>
            <Routes>
              {children.map((it, i) => {
                return renderRoute(it, i);
              })}
            </Routes>
          </route.layout> : <route.component />
        } >
        </Route>
      </>
    )


  };

  return (
    <>
      <TimezoneProiver>
        <ConfigProvider locale={zhCN}>
          <BrowserRouter>
            <Routes>
           
                {routes.map((it, i) => {
                  return (
                    <>
                      {renderRoute(it, i)}
                    </>
                  )
                })}
            

            </Routes>
          </BrowserRouter>
        </ConfigProvider>
      </TimezoneProiver>
    </>
  )

};
